import { useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa6";

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: "Can you help with scholarships?",
    answer:
      "Yes! Our Premium plan includes scholarship search assistance and application support. Scholarship Assistance is also available as an add-on service. We help identify opportunities you qualify for and craft compelling scholarship essays.",
  },
  {
    question: "What if I'm not sure which country to choose?",
    answer:
      "That's what we're here for! During your initial consultation, we discuss your academic goals, career aspirations, budget, and preferences to recommend the best-fit destinations and programs.",
  },
  {
    question: "Do I still need a visa after admission?",
    answer:
      "Yes, admission and visa are separate processes. We offer comprehensive visa services (see our Visa Services page) and our Premium plan includes visa application assistance.",
  },
  {
    question: "Do you assist with both undergraduate and postgraduate applications?",
    answer:
      "Absolutely. Whether you are looking for a bachelor's degree, a master's, or specialized postgraduate research, we guide you through the unique entry requirements and application deadlines for each level.",
  },
  {
    question: "Can I apply to universities in multiple countries through your service?",
    answer:
      "Yes. We support applications across various global destinations, including the USA, UK, Canada, Ireland, and Australia, allowing you to explore different geographic opportunities simultaneously.",
  },
  {
    question: "Do I pay my tuition fees through SeamlessVisa or directly to the university?",
    answer:
      "For transparency and security, all tuition fees are paid directly to your chosen educational institution. Our role is to guide you through the financial documentation required to prove these payments to immigration authorities.",
  },
];

const StudyAbroadFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="bg-white-f9 py-16 sm:py-24">
      <div className="mx-auto max-w-4xl px-6 lg:px-8">
        <div className="text-center">
          <p className="inline-flex rounded-full bg-blue-ea px-4 py-2 text-sm font-semibold text-blue-00">
            FAQ
          </p>
          <h2 className="mt-4 text-4xl font-light font-lato tracking-tight text-black-1a sm:text-5xl">
            Frequently{" "}
            <span className="text-blue-00 italic mx-1">Asked</span>{" "}
            Questions
          </h2>
          <p className="mt-4 text-lg leading-8 text-dark-6b">
            Everything you need to know about studying abroad with SeamlessVisa.
          </p>
        </div>

        <div className="mt-10 space-y-4">
          {faqItems.map((item, index) => {
            const isOpen = index === openIndex;

            return (
              <article
                key={item.question}
                className="rounded-2xl border border-grey-eb bg-white"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                  aria-expanded={isOpen}
                  aria-controls={`study-faq-panel-${index}`}
                  id={`study-faq-trigger-${index}`}
                >
                  <span className="text-lg font-semibold text-black-1a">
                    {item.question}
                  </span>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-ea text-blue-00">
                    {isOpen ? <FaMinus size={12} /> : <FaPlus size={12} />}
                  </span>
                </button>

                <div
                  id={`study-faq-panel-${index}`}
                  role="region"
                  aria-labelledby={`study-faq-trigger-${index}`}
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 text-base leading-7 text-dark-6b">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StudyAbroadFAQ;
